































import { isViewAsSelected } from "@/store/modules/TargetUserModule";
import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";

import { IresDevice } from "@/data/models/IresDevice";
import { ProgramChain } from "@/data/models/ProgramChain";
import { HyDryEventLog } from "@/data/models/HyDryEventLog";
import HyDryEventLogItemComponent from "./HyDryEventLogItem.vue";
import {
  deleteHyDryEventLogNote,
  deleteHyDryEventLog,
  saveHyDryEventLog,
} from "@/data/repository/HyDryLogsRepository";
import {
  getActiveUser,
  getActiveUserId,
} from "@/data/repository/UserRepository";
import { firestore } from "firebase";
import { getClientId } from "@/data/repository/ClientRepository";
import { joinToString } from "@/utils/LocalisationHelper";
import { formatDate } from "@/utils/DateFormatter";
import {
  getHyDryEventFromEventNumber,
  HyDryEvent,
} from "@/data/models/HyDryEvent";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
    "hydry-event-log-item": HyDryEventLogItemComponent,
  },
})
export default class HyDryEventLogDetailsComponent extends Vue {
  @Prop()
  iresDevice!: IresDevice;

  @Prop()
  programChain!: ProgramChain;
  @Prop() doesSupportExtendedSensors!: boolean;

  hyDryEventLog: HyDryEventLog | null = null;

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  noteText = "";

  async show(log: HyDryEventLog) {
    this.hyDryEventLog = log;

    const defaultNoteText =
      joinToString(
        [formatDate(new Date(), "dd.MM.yyyy HH:mm"), getActiveUser()?.nickname],
        " / "
      ) + "\n";

    this.noteText = log.note?.text ?? defaultNoteText;

    this.baseDialogComponent.show({
      title: this.$t("hyDryEventLog.log").toString(),
      // Read only while "Sicht auf" is active (ticket 2610051): no save, no delete.
      positiveButtonText: isViewAsSelected() ? null : this.$t("common.save").toString(),
      negativeButtonText: isViewAsSelected()
        ? this.$t("common.close").toString()
        : this.$t("common.abort").toString(),
      neutralButtonText: log.note && !isViewAsSelected()
        ? this.$t("hyDryEventLog.deleteNote").toString()
        : null,
      maxWidth: 800,
      closeOnSave: false,
      closeOnNeutralAction: false,
      persistent: true,
    });
  }

  async onDelete() {
    const log = this.hyDryEventLog;

    if (!log) {
      return;
    }

    if (log.eventNumber === getHyDryEventFromEventNumber(HyDryEvent.NOTE)) {
      await deleteHyDryEventLog(log.id, this.iresDevice.serialNo);
    } else {
      await deleteHyDryEventLogNote(log.id, this.iresDevice.serialNo);
    }

    this.baseDialogComponent.isShowing = false;
  }

  async onSave() {
    const log = this.hyDryEventLog;

    if (!log) {
      return;
    }

    const note = {
      createdAt: firestore.Timestamp.now(),
      createdByClientId: getClientId(),
      createdByUserId: getActiveUserId() as string,
      createdByUserNickname: getActiveUser()?.nickname ?? "",
      text: this.noteText,
    };

    log.note = note;

    await saveHyDryEventLog(this.iresDevice.serialNo, log);

    this.baseDialogComponent.isShowing = false;
  }
}
